var config = require('js/config');

// Expose some global boot data
window.bootData = {};

var get = function(url) {
  try {
    var xhr = window.ActiveXObject ? new window.ActiveXObject('Microsoft.XMLHTTP') : new window.XMLHttpRequest();

    // Open a new request
    xhr.open('GET', url, true);

    // Ensure we deal with json
    xhr.setRequestHeader('Accept', 'application/json');
    //TODO pick it up from the build, cookie etc.
    xhr.setRequestHeader('Accept-Language', 'en');

    if (config.build.apiPath !== '') {
      // For CORS request between Ecliptic and Wepback server
      xhr.withCredentials = true;
    }

    return xhr;
  } catch (e) {
    return null;
  }
};

// Bootstrap context fetching data
var loc = location.pathname.split('/');
var groupCode = loc[1] === 'write' || loc[1] === 'follow' || loc[1] === 'user' ? loc[2] : loc[1];

var contextReq = null;

if (!location.hash) {
  contextReq = get(`${config.build.apiPath}/api/context?url=${groupCode}`);
  window.bootData[`${config.build.apiPath}/api/context`] = contextReq;

  if (contextReq) {
    contextReq.send();
  }
}



// WEBPACK FOOTER //
// ./app/assets/js/boot.js